import { render, staticRenderFns } from "./FilterSortPane.vue?vue&type=template&id=b5512688&"
import script from "./FilterSortPane.vue?vue&type=script&lang=ts&"
export * from "./FilterSortPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports